/**
 * The DaVinci logo (#648), as drawn on RegInvitePc.dc.html: the wordmark in ink, then three round dots in the three
 * course dot colours. The dots are decorative and never change with the focused course.
 *
 * In the app shell it is a link to Home (Wireflow: "DaVinci logo or Home tab, from any screen"), so it takes the
 * accessible name of that link; in the auth layout it is plain text.
 */

import { Link } from 'react-router';

function Dots(): React.JSX.Element {
  return (
    <span className="app-logo-dots" aria-hidden="true">
      <span />
      <span />
      <span />
    </span>
  );
}

export function Logo({ homeLabel }: { readonly homeLabel?: string }): React.JSX.Element {
  if (homeLabel === undefined) {
    return (
      <p className="app-logo" dir="ltr">
        DaVinci
        <Dots />
      </p>
    );
  }
  return (
    <Link className="app-logo" to="/" dir="ltr" aria-label={`DaVinci, ${homeLabel}`}>
      DaVinci
      <Dots />
    </Link>
  );
}
